// Jamlabs Hosted Development Environment
const host = 'https://test';

const dashboards = {
  fixedincome: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `22839260-2cb5-4cf1-885a-15b55ea3a8c7`,
      tradedetails: `58f090aa-da99-4f12-8242-11c145769d06`,
      outliers: `6bb93637-3008-4965-b433-05801054b10d`,
      pmoverview: `6bf6703e-e421-40ab-9ac1-0a12f78f08a2`,
      traderoverview: `150d0a28-7866-4624-aeb7-b0d10eb7395c`,
    },
  },
  fx: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `mock-id`,
      tradedetails: `mock-id`,
      outliers: `mock-id`,
      pmoverview: `mock-id`,
      traderoverview: `mock-id`,
    },
  },
  fxforward: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `mock-id`,
      tradedetails: `mock-id`,
      outliers: `mock-id`,
      pmoverview: `mock-id`,
      traderoverview: `mock-id`,
    },
  },
  irs: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `mock-id`,
      tradedetails: `mock-id`,
      outliers: `mock-id`,
      pmoverview: `mock-id`,
      traderoverview: `mock-id`,
    },
  },
};

const config = {
  uploadsItemsPerPage: 7,
  uploadsPaginationItems: 10,
  uploadsPreviewColumns: 8,
  bepActiveFlag: true,
  repLinearActiveFlag: true,
  fepSpotActiveFlag: true,
  fepForwardsActiveFlag: true,
  fepNonLinearActiveFlag: false,
  endpoints: {
    uploadDetails: `${host}/upload-details`,
    getUploadUrl: `${host}/get-upload-url`,
    uploads: `${host}/uploads`,
    mapUpload: `${host}/map-upload`,
    downloadFile: `${host}/download-file`,
    deleteIngest: `${host}/delete-ingest`,
    cancelIngest: `${host}/cancel-ingest`,
    approveVerificationReport: `${host}/approve-verification-report`,
    requestAccount: `${host}/request-account`,
    getUserData: `${host}/get-user-data`,
    verifyUserToken: `${host}/verify-user-token`,
    getThoughtSpotToken: `${host}/get-thoughtspot-token`,
    getJittoEmbedToken: `${host}/get-jitto-embed-token`,
    preferences: `${host}/user-preferences`,
    getLogUrl: `${host}/get-log-url`,
    mappingAdmin: `${host}/mapping-admin`,
    mappingAdminValues: `${host}/mapping-admin-values`,
    getMappingAuditTrail: `${host}/mapping-audit-trail`,
  },
  uploadValidationPollInterval: 5000,
  oktaAccountManagementLink:
    'https://parameta-accounts.okta.com/enduser/settings?fromLogin=true',
  // Jitto Answer embed (ANS-545): off until UAT signs the Jitto Answer dashboards off. When on, a
  // dashboard with an embedded uuid in config/jittoDashboards.json renders from
  // Jitto Answer and every other one shows a notice; nothing asks ThoughtSpot
  // (no ThoughtSpot embed, AI Assistant, dashboard builder or logout). When off,
  // all of it is ThoughtSpot.
  jittoEmbedActiveFlag: false,
  // The tenant's own Jitto host: @jitto/analyze-embed frames only <this>/embed (ANS-678).
  jittoEmbedOrigin: '',
  // Jitto applies host filters (filters on mount, setFilters): @jitto/analyze-embed 0.3.0 (ANS-801).
  // Only read with the Jitto embed on: before turning that on here, this environment's Jitto must
  // run jitto-analyze#540 with EMBED_HOST_FILTERS on and single_choice listed, and its token
  // function must pass filter_bar on, or every dashboard with Ccy fails.
  jittoHostFilters: true,
  thoughtSpotHost: 'https://test-thoughtspot',
  authProvider: 'okta',
  okta: {
    issuer: 'https://parameta-accounts.okta.com/oauth2/default',
    clientId: '0oa131qon7hilhvva417',
    pkce: false,
    tokenManager: {
      storage: 'cookie',
    },
    cookies: {
      sessionCookie: true,
    },
  },
  fxCurrencies: [
    'USD',
    'CAD',
    'CNY',
    'CHF',
    'AUD',
    'JPY',
    'EUR',
    'GBP',
    'NZD',
    'HKD',
    'SEK',
    'SGD',
  ].sort(),
  requestAccountActionURL:
    'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  requestAccountRetURL: 'https://tpicaptca.dev.jamlabs.com/requestaccount',
  dashboards,
};

export default config;
